import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  user: null,
  token: null,
  error: null,
};

export const login = createAsyncThunk("auth/login", async ({ email, password }, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/login`, { email, password });
    console.log("Login response:", response.data.data); 
    return response.data.data; // expects { user, token }
  } catch (error) {
    return rejectWithValue({
      message: error.response?.data?.message || error.message,
      code: error.response?.data?.code || "unknown_error",
    });
  }
});

export const googleLogin = createAsyncThunk("auth/googleLogin", async (credential, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/google`, { credential });
    return response.data.data; // expects { user, token }
  } catch (error) {
    return rejectWithValue({
      message: error.response?.data?.message || error.message,
      status: error.response?.status,
    });
  }
});

export const logout = createAsyncThunk("auth/logout", async (_, { rejectWithValue }) => {
  try {
    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`);
    return null;
  } catch (error) {
    return rejectWithValue({ code: error.code, message: error.message });
  }
});

export const accountUpdate = createAsyncThunk("auth/accountUpdate", async (cleanAccount, { rejectWithValue }) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/auth/accountupdate`, cleanAccount);
    return response.data.data.user;
  } catch (error) {
    return rejectWithValue({ code: error.code, message: error.message });
  }
});

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // Admin dashboard sidebar order (JSON string of item ids, or null for default)
    setNavOrder: (state, action) => {
      if (state.user) state.user.dashboardNavOrder = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(googleLogin.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.token = null;
      })
      .addCase(accountUpdate.fulfilled, (state, action) => {
        state.user = action.payload;
      });
  },
});

export const { setNavOrder } = authSlice.actions;
export default authSlice.reducer;
